<template>
  <v-app-bar id="app-bar" app color="primary" dark v-if="showAppbar">
    <v-btn class="mr-3" elevation="0" color="primary" fab small @click="setDrawer(!drawer.drawer)">
      <v-icon v-if="value">mdi-view-quilt</v-icon>

      <v-icon v-else>mdi-menu</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down font-weight-light"> {{$t($route.name)}} </v-toolbar-title>

    <v-spacer />

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div
          class="user-info"
          v-on="on"
        >{{ loggedClient || $t('keywords.env') }} / {{ loggedUserName || $t('keywords.user') }}</div>
      </template>
      <span>{{$t('keywords.env')}} / {{$t('keywords.user')}}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <LocaleSwitcher />
        </div>
      </template>
      <span>{{ $t("language") }}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn @click="selectClient" icon v-on="on">
          <v-icon>mdi-account-switch</v-icon>
        </v-btn>
      </template>
      <span>{{$t('keywords.select_client')}}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn @click="logout" icon v-on="on">
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
      </template>
      <span>{{$t('keywords.logout')}}</span>
    </v-tooltip>

    <ConnectionIcon />
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import LocalStorageService from '../../services/LocalStorageService'
import ClientService from '../../services/ClientService'
import LocaleSwitcher from '../../i18n/LocaleSwitcher'
import ConnectionIcon from './ConnectionIcon.vue'

export default {
  name: 'AppBar',

  components: { LocaleSwitcher, ConnectionIcon },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    statusResult: false,
    showAppbar: true,
    loggedUserName: '',
    loggedClient: ''
  }),

  computed: {
    ...mapState(['drawer'])
  },

  watch: {
    $route (to, from) {
      this.checkRoute(to.fullPath)
    }
  },

  created () {
    this.checkRoute(this.$router.currentRoute.fullPath)
    this.getUserInfo()
  },

  updated () { this.getUserInfo() },

  methods: {
    getUserInfo () {
      this.loggedUserName = LocalStorageService.getUsername()
      if (!this.loggedClient && this.showAppbar) {
        ClientService.findById(LocalStorageService.getClientPrefix())
          .then(details => {
            LocalStorageService.setClientName(details.data.clientName)
          })
          .catch(error => console.error(error))
      }
      this.loggedClient = LocalStorageService.getClientName()
    },
    selectClient () {
      this.$router.push('/select-client')
    },

    logout () {
      this.$router.push('/logout')
    },

    checkRoute (path) {
      if (path === '/login' || path === '/select-client') {
        this.showAppbar = false
      } else {
        this.showAppbar = true
      }
    },

    ...mapMutations(['setDrawer'])
  }
}
</script>
<style scoped>
.user-info {
  margin-right: 10px;
}
</style>
